(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["order-addon"] && !Shopify.designMode) return;
  try {
    class OrderAddon extends HTMLElement {
    #busy = false;

    connectedCallback() {
      document.addEventListener('click', this.#onClick, true);
      document.addEventListener('keydown', this.#onKeydown, true);
      this.addEventListener('change', this.#onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onClick, true);
      document.removeEventListener('keydown', this.#onKeydown, true);
      this.removeEventListener('change', this.#onChange);
    }

    // Exclusion mutuelle entre accessoires qui se recouvrent. Le verre
    // standard et le pack sécurité protègent tous deux l'écran, et un seul
    // verre se pose sur un écran ; le pack sécurité contient par ailleurs une
    // coque, donc il recouvre aussi l'option coque seule. Coché avec elle, il
    // ferait partir deux coques.
    //
    // Un accessoire peut donc déclarer PLUSIEURS groupes, séparés par des
    // virgules : le pack sécurité porte « protection-ecran,coque » et exclut
    // les deux options individuelles d'un coup.
    //
    // Ce sont des cases et non des boutons radio, à dessein : un groupe de
    // radios ne se décoche plus une fois coché, et le client doit pouvoir
    // revenir à « aucun » sans recharger la page.
    #groupesDe(input) {
      return (input.dataset.groupe || '')
        .split(',')
        .map((g) => g.trim())
        .filter(Boolean);
    }

    #onChange = (event) => {
      const input = event.target;
      if (!input.classList?.contains('addon__check') || !input.checked) return;

      const groupes = this.#groupesDe(input);
      if (groupes.length === 0) return;

      this.querySelectorAll('.addon__check').forEach((autre) => {
        if (autre === input || !autre.checked) return;
        if (this.#groupesDe(autre).some((g) => groupes.includes(g))) autre.checked = false;
      });
    };

    get #checked() {
      return Array.from(this.querySelectorAll('.addon__check'))
        .filter((input) => input.checked)
        .map((input) => input.dataset.variantId)
        .filter(Boolean);
    }

    // On intercepte le CLIC, pas la soumission. Deux tentatives d'interception
    // du submit ont échoué le 1er septembre 2026, et pour la même raison :
    // assets/component.js pose son écouteur `on:` sur document en phase de
    // capture, au démarrage du thème, donc avant tout bloc. Impossible de
    // passer devant lui — l'écran partait au panier en parallèle de notre
    // requête, les deux appels concurrents se perdaient, et la relance
    // ajoutait l'écran une seconde fois.
    //
    // Le clic, lui, est libre : aucun `on:click` n'est déclaré sur le bouton
    // d'ajout ni sur ses ancêtres. On peut donc l'annuler sans rien casser,
    // insérer l'accessoire, puis rendre la main au thème. Comme l'accessoire
    // est déjà au panier quand le thème envoie sa requête, les sections qu'il
    // récupère contiennent les deux articles : le tiroir ne se dessine qu'une
    // fois.
    #onClick = (event) => {
      const container = event.target.closest?.('add-to-cart-component');
      if (!container) return;

      const form = container.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      this.#intercept(event, form);
    };

    // La touche Entrée depuis le champ de quantité soumet le formulaire sans
    // passer par un clic. On la ramène au même chemin.
    #onKeydown = (event) => {
      if (event.key !== 'Enter') return;

      const form = event.target.closest?.('form[data-type="add-to-cart-form"]');
      if (!form) return;

      this.#intercept(event, form);
    };

    #intercept(event, form) {
      if (this.#busy) return;

      const ids = this.#checked;
      if (ids.length === 0) return;

      event.preventDefault();
      event.stopPropagation();

      this.#busy = true;
      this.classList.add('addon--busy');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
      })
        .then((response) => {
          // Un accessoire épuisé entre l'affichage et le clic ne doit jamais
          // empêcher la vente de l'écran : on note et on continue.
          if (!response.ok) console.warn('[order-addon] accessoire non ajouté', response.status);
        })
        .catch((error) => console.warn('[order-addon] accessoire non ajouté', error))
        .finally(() => {
          // Décocher avant de relancer : sans cela, un second ajout depuis la
          // même page rajouterait l'accessoire une deuxième fois.
          this.querySelectorAll('.addon__check').forEach((input) => {
            input.checked = false;
          });

          this.classList.remove('addon--busy');
          this.#busy = false;

          form.requestSubmit();
        });
    }
  }

  if (!customElements.get('order-addon')) {
    customElements.define('order-addon', OrderAddon);
  }
  } catch(e) { console.error(e); }
})();

})();
